export default __webpack_public_path__ + "static/media/card.3481fe11.webp";